/**
 * Where to price things when nobody will say where they are.
 *
 * Someone who refuses a location prompt has not refused the feature — they have
 * refused a prompt, and the two are very different requests. India is the only
 * market Larder targets (docs/product/scope.md), so a country-wide search is a
 * good answer rather than a placeholder: verified live, `location=India`
 * returns forty real offers with real prices, the same as a city does.
 *
 * What it loses is the local half. Quick-commerce availability and price are
 * per-pincode, so a country-wide answer skews towards the national sellers and
 * may quote a shop that does not deliver to this street. That is why the screen
 * says which it is using and offers the upgrade — see `isCountryWide`.
 */
export const ANYWHERE_IN_INDIA = {
    // SerpApi's own canonical name for the country. Its Locations API lists it as
    // `target_type: "Country"`, which is what makes this a real target and not a
    // string we invented.
    id: "",
    name: "India",
    canonicalName: "India",
    countryCode: "IN",
    at: 0,
};
/**
 * Is this the fallback rather than a real city?
 *
 * Checked on the canonical name because that IS the identity as far as Google
 * is concerned — a city's canonical name always carries its state and country
 * ("Bengaluru,Karnataka,India"), so a bare country name cannot be one.
 */
export function isCountryWide(where) {
    return !!where && !where.canonicalName.includes(",");
}
//# sourceMappingURL=place.js.map